export class AMQuickLinks {
    init() {
        const bgImage = document.getElementById("quick_links_image") as HTMLImageElement | null;

        if (bgImage) {
            const randomNumber = this.getRandom(0, 10);
            bgImage.src = `/Static/AMQuicklinks/AM_QuickLinks_${randomNumber + 1}.jpg`;
        }
    }

    private getRandom(min: number, max: number): number {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min; // The maximum is exclusive and the minimum is inclusive
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const quickLinks = new AMQuickLinks()
    quickLinks.init()
})